import { render, staticRenderFns } from "./configureEvents.vue?vue&type=template&id=df33b8fe&scoped=true"
import script from "./configureEvents.vue?vue&type=script&lang=js"
export * from "./configureEvents.vue?vue&type=script&lang=js"
import style0 from "./configureEvents.vue?vue&type=style&index=0&id=df33b8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df33b8fe",
  null
  
)

export default component.exports